<template>
  <div v-if="bodyShow" ref="island_report" class="island-report" :style="{background:island[bg_type].backg,backgroundSize: 'cover'}">
    <!-- 活动规则和金币 -->
    <div  @click="$router.push('/ceping80_activity_rules')" class="left-text">活动规则</div>
    <div class="userinfo">
        <div class="money">
            <img  src="@a/ceping80/money-mini.png" alt="">{{userInfo.score}}
        </div>
        <img :src="userInfo.headimgurl" class="user-img-link" alt="">
    </div>
    <!-- 三叶草勋章 判断是否是第一次进来-->
    <img v-if="bx_list.length>=3 && sycMiniShow && syc_shou" @load="smLoad()" @click="smHandles2()" class="sycxz-mini" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/sycxz-mini.png" alt="">
    <img v-else-if="bx_list.length>=3 && sycMiniShow" @click="toCloverHandle()" class="sycxz-mini" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/sycxz-mini.png" alt="">
    <!-- 初次小手提示-三叶草勋章 -->
    <img @click="smHandles2()" v-if="bx_list.length>=3 && sycMiniShow && syc_shou" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/hand.png" :class="['hand',bg_type=='E'?'E on':'on']"  alt="">
    <!-- 引导蒙层 -->
    <div @click="smHandles2()" v-if="bx_list.length>=3 && sycMiniShow && syc_shou" class="bgc on"></div>
    
    <!-- 初次小手提示---开宝箱 -->
    <img @click="smHandles()" v-if="bx_list.length==0 && small_shou" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/hand.png" :class="['hand',bg_type=='E'?'E':'']"  alt="">
    <!-- 引导蒙层 -->
    <div @click="smHandles()" v-if="bx_list.length==0 && small_shou" class="bgc"></div>
    <!-- text -->
    <div class="content">
        <h4>恭喜你<br/>成为{{island[bg_type].title}}的第<span class="on">{{userInfo.select_list[0] && userInfo.select_list[0].count?userInfo.select_list[0].count:''}}</span>位访客</h4>
        <p>生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”</p>
    </div>

    <img @click="bxHandle('left')" :class="['bx-left ',!bx_type_arr.includes('left')?'animated pulse infinite':'']" :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_type_arr.includes('left')?'bx-left':'bx-close'}.png`"  alt="">
    <!-- 判断是否是第一次进来 -->
    <img v-if="small_shou" @click="smHandles()" :class="['bx-top ',bg_type=='E'?'E':'',!bx_type_arr.includes('top')?'animated pulse infinite':'']" :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_type_arr.includes('top')?'bx-top':'bx-bottom'}.png`"  alt="">
    <img v-else @click="bxHandle('top')" :class="['bx-top ',bg_type=='E'?'E':'',!bx_type_arr.includes('top')?'animated pulse infinite':'']" :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_type_arr.includes('top')?'bx-top':'bx-bottom'}.png`"  alt="">
    <!--  -->
    <img @click="bxHandle('bottom')" :class="['bx-bottom ',!bx_type_arr.includes('bottom')?'animated pulse infinite':'']" :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_type_arr.includes('bottom')?'bx-top':'bx-bottom'}.png`"  alt="">
    <img class="shu" src="@a/ceping80/shu.png" alt="">

    <!-- 底部未合成 -->
    <img  @click="synthesisHandle()" v-if="bx_list.length>=3 && !sycMiniShow && !receiveMedalShow && !sycModelShow " class="hc animated pulse infinite" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/hc.png" alt="">
    <!-- 领取勋章 -->
    <van-popup class="sland-report-pop" v-model="receiveMedalShow">
        <!-- 金币效果 -->
        <span v-if="money_xf" class="money-css"><img src="@a/ceping80/money-mini.png" alt="">-50</span>
        <div class="box2">
            <div class="bg">
                <h4>恭喜你获得{{bx_list[bx_idx]}}勋章</h4>
                <div v-if="bx_list.length>=3" class="text">终于集齐三个勋章，合成勋章<span>开启大奖</span>吧</div>
                <div v-else class="text">再解锁{{3-bx_list.length}}个宝箱即可开启<span>99元</span>课程大奖</div>
                <img class="xunzhang" :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${receiveMedal_type}.png`" alt="">
                <!-- 勋章进度 -->
                <div class="xunzhang-progress">
                    <img  :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_list.length>=1?'bx-mini-on':'bx-mini'}.png`" alt="">
                    <img :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_list.length>=2?'bx-mini-on':'bx-mini'}.png`"  alt="">
                    <img  :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${bx_list.length>=3?'bx-mini-on':'bx-mini'}.png`"  alt="">
                    <div  class="bar">
                        <div :style="{width:bx_list.length==1?'25%':(bx_list.length==2?'75%':(bx_list.length==3?'100%':'0'))}"></div>
                    </div>
                </div>
                <!--  -->
                
                <button v-if="bx_list.length>=3 && !money_xf && sycMiniShow"  @click="toCloverHandle()" class="button">查看课程</button>
                <button v-else  @click="receiveMedal()" class="button">{{bx_list.length< 3?'开心收下':'合成'}}</button>
            </div>
            <!-- <img :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping80/${receiveMedal_type}.png`" alt="">
            <a class="btn" @click="receiveMedal()">开心收下</a> -->
        </div>
    </van-popup>
    <!-- 合成勋章 -->
    <van-popup class="sland-report-pop syc" v-model="sycModelShow">
        <div class="box">
            <h5>幸福三叶草</h5>
            <img class="syc-img" src="@a/ceping80/sycxz.png" alt="">
            <a class="btn" @click="receiveHandle()">收下课程</a>
            <p>更多章节，敬请期待…</p>
        </div>
    </van-popup>
    <!-- 分享海报 -->
    <van-popup class="sland-report-poster" v-model="posterShow">
        <img :src="posterLink" alt="">
        <p class="text">每成功邀1人得100探索币，邀请1人即可开大奖。</p>
        <p class="text">长按保存至相册邀请好友</p>
    </van-popup>
  </div>
</template>

<script>
import { ceping80_info,ceping80_poster,ceping80_log_activity,ceping80_reset,getData,saveData } from "@/api/measurement";
import { isMain,getStorage, setStorage, deleteStorage} from "@/utils/tools";
import { deepCopy } from "@/utils/tools";
export default {
    data(){
        return{
            bodyShow:false,
            bg_type:'',
            cid:80,
            island:{
                E:{
                    title:'显赫富庶岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/xhfsd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                },
                I:{
                    title:'深思冥想岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/ssmxd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                },
                S:{
                    title:'温暖友善岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/wlysd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                },
                A:{
                    title:'美丽浪漫岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/mllmd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                },
                C:{
                    title:'现代井然岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/xdjrd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                },
                R:{
                    title:'自然原始岛',
                    backg:"url('https://themes-cdn.xjy.cn/statics/career/images/ceping80/zrysd1.png')  no-repeat",
                    content:'生涯发展过程中，找到自己爱干、能干、值得干的事是幸福的。点击开启岛上的宝箱，集齐三个神秘勋章，铸造属于你的“幸福三叶草”'
                }
            },
            userInfo:{},
            // 存储以打开的宝箱
            bx_list:[],
            receiveMedal_type:'',
            receiveMedalShow:false,
            bx_type_arr:[],
            // 分享海报
            posterShow:false,
            posterLink:'',
            sycModelShow:false,
            // 显示三叶草勋章
            sycMiniShow:false,
            // 小手
            small_shou:true,
            syc_shou:true,
            // 判断是立马合成
            synthesis:true,
            // 存储数据
            storage_data:{},
            // 存储打开宝箱位置下标
            bx_idx:null,
            money_xf:true
        }
    },
    mounted(){
            

        if(this.small_shou){
            setTimeout(()=>{
                this.small_shou = false;
                this.storage_data['small_shou'] = 1; 
                setStorage(this.$route.path,'small_shou',1)
            },3000);
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 初次三叶草勋章合成后显示小手引导触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-30 11:31:56
        */
        smLoad(){
            setTimeout(()=>{
                this.smHandles2();
            },3000);
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初次合成三叶草勋章直接合成返回后，点击小三叶草勋章触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-30 11:29:58
        */
        smHandles2(){
            this.syc_shou = false;
            // 
            this.storage_data['syc_shou'] = 1; 
            setStorage(this.$route.path,'syc_shou',1);
        },
        /*
         *@param: 
         *@return: 
         *@Description: 宝箱初次小手提示层，点击触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-30 11:30:44
        */
        smHandles(){
            this.small_shou = false;
            // 
            this.storage_data['small_shou'] = 1; 
            setStorage(this.$route.path,'small_shou',1);
        },
        /*
         *@param: 
         *@return: 
         *@Description: 跳转到三叶草页面
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 15:45:05
        */
        toCloverHandle(){
            this.$router.push('/ceping80_clover');
        },
        /*
         *@param: 
         *@return: 
         *@Description: 合成三叶草勋章
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 14:35:12
        */
        synthesisHandle(){
            //合成中
            this.$emit("loadingHandle", true, "合成中...");
            // if(this.userInfo.score>=200 && this.bx_list.length>=3){
            if(this.bx_list.length>=3){
                //关闭加载中
                this.$emit("loadingHandle", false);
                this.sycModelShow = true;
                this.synthesis = false;
            }else{
                this.getPoster();
                
            }
        },
        /*
         *@param: 
         *@return: 
         *@Description: 获取海报
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 18:56:21
        */
        getPoster(){
            
            ceping80_poster({
                // link:`https://open.xjy.cn/${isMain()?'main':'test'}/ceping80_follow?share_uid=${this.userInfo.uid}`,
                extra:this.$route.query.extra
            }).then((data)=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                this.posterLink = data.poster;
                setTimeout(()=>{
                    this.posterShow = true;
                    this.storage_data['syc_shou'] = 1; 
                    setStorage(this.$route.path,'syc_shou',1);
                },1000);
                this.$toast('离大奖只有一步啦，快点邀请好友赢探索币吧！');
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 领取三叶草勋章
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-27 16:53:34
        */
        receiveHandle(){
            // if(this.syc_shou){
                // setTimeout(()=>{
                //     this.syc_shou = false;
                //     setStorage(this.$route.path,'syc_shou',1);
                // },3000);
                // this.syc_shou = false;
                
            // }
            // 判断是否是初次立马 合成
            // if(this.synthesis){
            //     this.sycModelShow = false;
            //     this.sycMiniShow = true;
            //     if(this.syc_shou){
            //         setTimeout(()=>{
            //             this.syc_shou = false;
            //             setStorage(this.$route.path,'syc_shou',1);
            //         },3000);
            //     }
            //     setStorage(this.$route.path,'syc_shou',1);
            // }else{
                this.storage_data['syc_shou'] = 2; 
                setStorage(this.$route.path,'syc_shou',2);
                this.toCloverHandle();
            // }
            
        },
        /*
         *@param: 
         *@return: 
         *@Description: 领取勋章
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 11:53:23
        */
        receiveMedal(val){
            if(this.bx_list.length>=3){
                // if(this.syc_shou){
                //     setTimeout(()=>{
                //         this.syc_shou = false;
                //         setStorage(this.$route.path,'syc_shou',1);
                //     },3000);
                // }
                this.synthesis = true;
                // 存储打开的宝箱位置
                this.storage_data['sycMini'] = 1; 
                setStorage(this.$route.path,'sycMini',1);
                this.receiveMedalShow =  false;
                this.sycModelShow = true;
                // 
                // this.sycMiniShow = true;
            }else{
                this.receiveMedalShow = false;
            }
        },
        /*
         *@param: 
         *@return: 
         *@Description: 点击宝箱触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 11:08:26
        */
        bxHandle(val){
            if(this.bx_type_arr.includes(val)){
                let idx_ = this.bx_type_arr.indexOf(val);
                this.bx_idx = idx_;
                if(idx_==0){
                    this.receiveMedal_type = 'nl-on';
                }else if(idx_==1){
                    this.receiveMedal_type = 'xq-on';
                }else if(idx_==2){
                    this.receiveMedal_type = 'jzg-on';
                }
                this.money_xf = false;
                this.receiveMedalShow = true;
                // this.$toast({
                //     duration: 1000,
                //     message:'宝箱已打开！'
                // });
                return
            }

            //调用加载中
            this.$emit("loadingHandle", true, "宝箱开启中...");
            
            ceping80_log_activity({
                type:2,
                extra:this.bx_list.length==0?'能力':(this.bx_list.length==1?'兴趣':(this.bx_list.length==2?'价值观':''))
            }).then((data)=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
                if (data.code == "10002") {
                    // this.$toast(data.data.detail);

                    this.getPoster();
                    return
                }
                // 存储开启宝箱
                this.bx_type_arr = [...this.bx_type_arr,val];
                // 取得下标，存储宝箱对应的勋章类型
                this.bx_idx = this.bx_type_arr.indexOf(val);
                this.money_xf = true;
            
                // 存储打开的宝箱位置
                this.storage_data['seat'] = this.bx_type_arr; 
                this.saveDataHandle();
                setStorage(this.$route.path,'seat',this.bx_type_arr);
                // 第一个能力宝箱
                if(this.bx_list.length==0){
                    this.bx_list.push('能力');
                    this.receiveMedal_type = 'nl-on';
                    
                    // 第二个兴趣勋章
                }else if(this.bx_list.length==1){
                    this.bx_list.push('兴趣');
                    this.receiveMedal_type = 'xq-on';
                    // 第三个价值观勋章
                }else if(this.bx_list.length==2){
                    this.bx_list.push('价值观');
                    this.receiveMedal_type = 'jzg-on';
                }
                this.receiveMedalShow = true;

                this.pullData();
            });
            
            
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化获取数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 11:08:14
        */
        pullData(){
            // deleteStorage(this.$route.path);
            // deleteStorage('/ceping80');
            // ceping80_reset()
            this.bg_type = this.$route.query.extra;
            //调用加载中
            this.$emit("loadingHandle", true, "拼命加载中...");
            ceping80_info().then((data)=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
                document.title = '海岛历险';
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                // 判断是否登岛
                if(data.select_list.length==0){
                    this.$router.push('/ceping80');
                    return
                }


                this.userInfo = data;
                let arr  = [];
                data.open_list.map((item,index)=>{
                    arr.push(item.extra);
                });
                this.bx_list = [...new Set(arr)];
                // 获取数据
                this.getDataHandle();

                this.bodyShow = true;
            });
        },
        getDataHandle(){
            getData({
                cid:this.cid
            }).then((data)=>{
                this.storage_data = data.data?JSON.parse(data.data):{};
                // 获取打开的宝箱位置
                let seat = this.storage_data['seat']; 
                let seatStorage =  getStorage(this.$route.path,'seat');
                let bxType = this.userInfo.open_list;
                this.bx_type_arr = bxType && bxType.length>=3?["top", "left","bottom"]:(seat && seat.length>0?seat:(seatStorage && seatStorage.length>0?seatStorage:[]));
                // 
                let sycMini = this.storage_data['sycMini']; 
                // let sycMini = getStorage(this.$route.path,'sycMini');
                this.sycMiniShow = sycMini && sycMini==1?true:false;

                // 宝箱小手提示
                let small_shou_ = this.storage_data['small_shou']; 
                // let small_shou_ = getStorage(this.$route.path,'small_shou');
                this.small_shou = small_shou_ && small_shou_==1?false:true;
                // 三叶草勋章提示
                let syc_shou_ = this.storage_data['syc_shou']; 
                // let syc_shou_ = getStorage(this.$route.path,'syc_shou');
                this.syc_shou = syc_shou_ && syc_shou_==1?false:true;
                // 是否是初次未合成
                if(syc_shou_ && syc_shou_==2){
                    this.sycMiniShow = true;
                    setTimeout(()=>{
                        this.storage_data['sycMini'] = 1; 
                        this.storage_data['syc_shou'] = 1; 
                        setStorage(this.$route.path,'sycMini',1);
                        setStorage(this.$route.path,'syc_shou',1);
                        this.syc_shou = false;
                    },3000);
                }
                
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description:提交操作数据 
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-30 11:50:44
        */
        saveDataHandle(){
             // 同步缓存接口
            saveData({
                cid:this.cid,
                data:String(this.storage_data)!='{}'&&this.storage_data?JSON.stringify(this.storage_data):''
            }).then((data)=>{

            });
        }
    }, 
    destroyed(){
       this.saveDataHandle();
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss">
// 分享海报
.sland-report-poster{
    background: transparent;
    text-align: center;
    img{
        width: 560px;
        margin-bottom: 60px;
        border-radius: 20px;
    }
    .text{
        margin: 0 auto;
        font-size: 24px;
        color: #FFFFFF;
        // padding: 15px;
        line-height: 1;
        margin-bottom: 34px;
        // border: 1px solid #FFFFFF;
        border-radius: 10px;
    }
}
// 领取勋章
.sland-report-pop{
    background: transparent;
    .money-css{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 28px;
        color: #FCDE32;
        font-size: 36px;
        img{
            width: 43px;
            height: 43px;
            margin-right: 12px;
        }
    }
    .box{
        width: 590px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
            position: relative;
            z-index: -1;
        }
        .btn{
            display: block;
            position: absolute;
            transform: translateX(-50%);
            left: 50%;
            bottom: 60px;
            margin: 0 auto;
            width: 320px;
            height: 80px;
            background: linear-gradient(0deg, #FBE537 0%, #FFA107 100%);
            border-radius: 40px;
            color: #FFFFFF;
            text-align: center;
            line-height: 80px;
            font-size: 36px;
            text-shadow: 0px 2px 4px rgba(234, 138, 0, 0.53);

        }
    }
    .box2{
        width: 590px;
        // height: 639px;
        background: linear-gradient(0deg, #F7E1B5 0%, #FFF1D9 100%);
        padding: 20px;
        border-radius: 40px;
        
        .bg{
            padding: 40px 20px;
            border-radius: 40px;
            background: #ffffff;
            text-align: center;
            h4{
                color: #533414;
                font-size: 36px;
                line-height: 1;
                font-weight: bold;
                margin-bottom: 40px;
            }
            .text{
                color: #533414;
                font-size: 28px;
                line-height: 1;
                margin-bottom: 60px;
                font-weight: bold;
                span{
                    color: #FF3C3C;
                }
            }
            .xunzhang{
                width: 194px;
                margin-bottom: 28px;
            }
            .xunzhang-progress{
                display: flex;
                align-items: center;
                width: 362px;
                margin: 0 auto 32px;
                position: relative;
                img{
                    width: 44px;
                    height: 43px;
                    position: relative;
                    z-index: 2;
                    &:nth-child(2){
                        margin: auto;
                    }
                }
                .bar{
                    position: absolute;
                    left: 10px;
                    bottom: 12px;
                    background: #f9f9f9;
                    width:340px;
                    height: 15px;
                    border-radius: 8px;
                    overflow: hidden;
                    z-index: 1;
                    div{
                        background: #FFC400;
                        height: 100%;
                        border-radius: 8px;
                    }
                }
            }
            .button{
                width: 320px;
                height: 80px;
                background: linear-gradient(0deg, #FBE537 0%, #FFA107 100%);
                border-radius: 40px 40px 40px 40px;
                font-size: 36px;
                color: #FFFFFF;
                text-shadow: 0px 2px 4px rgba(234, 138, 0, 0.53);
                border: none;
            }
            
        }
        
    }
}
.sland-report-pop.syc{
    top: 40%;
    .box{
        width: auto;
        img.syc-img{
            width: 687px;
        }
        .btn{
            bottom:48px;
        }
        h5{
            font-size: 48px;
            color: #FDDD43;
            line-height: 1;
            text-align: center;
            display: block;
            position: absolute;
            transform: translateX(-50%);
            left: 50%;
            top: 125px;
        }
        p{
            font-size: 24px;
            color: #FFFFFF;
            text-align: center;
            padding-top: 28px;
        }

    }
}
</style>
<style lang="scss" scoped>
.island-report{
    position: absolute;
    width: 750px;
    height: 1334px;
    left: 0;
    top: 0;
    overflow-x: hidden;
    .hc{
        width: 375px;
        height: 107px;
        position: absolute;
        left: 187px;
        bottom: 60px;
        z-index: 887;
    }
    // 金币和规则
    .left-text{
        position: absolute;
        top: 30px;
        left: 0;
        width: 130px;
        line-height: 40px;
        font-size: 24px;
        color: #FFFFFF;
        background: rgba($color: #ffffff, $alpha: .5);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        padding-left: 6px;
    }
    .userinfo{
        position:absolute;
        right: 30px;
        top: 30px;
        display: flex;
        align-items: center;
        .money{
            width: 100px;
            height: 40px;
            background: rgba($color: #ffffff, $alpha: 0.5);
            border-radius: 20px;
            font-size: 24px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            img{
                width: 32px;
                height: 32px;
                margin-right: 8px;
                margin-left: 5px;
                -webkit-animation: slateY1 2s linear infinite;
                animation:slateY1 2s linear infinite;
            }
            
            @keyframes slateY1 { 
                from { /*动画起始状态*/
                -webkit-transform: rotate(0deg);
                }
                to { /*动画结束状态*/
                -webkit-transform: rotateY(360deg);
                }
            }
        }
        .user-img-link{
            margin-left: 20px;
            width: 64px;
            height: 64px;
            border-radius: 50%;
            background-color: #f0f0f0;
        }
    }
    .sycxz-mini{
        width: 80px;
        height: 52px;
        position: absolute;
        z-index: 968;
        top: 125px;
        right: 26px;
    }
    .content{
        margin: 120px auto;
        width: 505px;
        text-align: center;
        h4{
            font-size: 36px;
            color: #ffffff;
            text-shadow: 0px 3px 0px #0089CF;
            line-height: 60px;
            margin-bottom: 20px;
            font-weight: bold;
            span.on{
                color: #F9FF5D;
            }
        }
        p{
            text-indent: 2em;
            font-size: 24px;
            color: #ffffff;
            line-height: 36px;
            font-weight: bold;
            text-shadow: 0px 3px 0px rgba(0, 112, 207, 0.3);
        }
    }
    .bx-left{
        position: absolute;
        left: 2px;
        top: 792px;
        width: 127px;
        height: 126px;
    }
    .bx-top{
        position: absolute;
        left: 451px;
        top: 627px;
        width: 127px;
        height: 126px;
        z-index: 887;
    }
    .bgc{
        position: absolute;
        width: 750px;
        left: 0;
        top: 0;
        z-index: 788;
        background: rgba($color: #000000, $alpha: .6);
        height: 100%;
    }
    .hand{
        position: absolute;
        left: 523px;
        top: 674px;
        width: 60px;
        height: 60px;
        z-index: 998;
        // background: url('') center no-repeat;
        // background-size: 100% 100%;
        animation:hand 1.5s linear infinite;
    }
    .bgc.on{
        z-index: 888;
    }
    .hand.on,.hand.E.on{
        top: 150px;
        right: 20px;
        left: auto;
    }
    .hand.E{
        left: 441px;
        top: 763px;
    }
    @keyframes hand { 
        0% { /*动画起始状态*/
            transform: scale(1);
        }
        25% { /*动画起始状态*/
            transform: scale(1.2);
        }
        50% { /*动画起始状态*/
            transform: scale(1.5);
        }
        75%{ /*动画结束状态*/
            transform: scale(1.2);
        }
        100%{
            transform: scale(1);
        }
    }
    .bx-top.E{
        top: 717px;
        left: 371px;
        z-index: 887;
    }
    .bx-bottom{
        position: absolute;
        right: 80px;
        bottom: 156px;
        width: 127px;
        height: 126px;
    }
    .shu{
        position: absolute;
        right: -25px;
        bottom: 107px;
        // width: 166px;
        height: 165px;
        z-index: 5;
    }

    .footer{
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 888;
        width: 100%;
        max-width: 750px;
        height: 278px;
        background: #FFEEBE;
        border: 6px solid #E1AC66;
        border-radius: 160px 160px 0px 0px;
        text-align: center;
        .xingxing{
            display: flex;
            justify-content: center;
            padding-top: 43px;
            margin-bottom: 42px;
            img{
                margin-right: 100px;
                width: 110px;
                height: 98px;
                &:last-child{
                    margin-right: 0;
                }
            }
            img.on{
                animation:slateZ1 3s linear infinite;
            }
            @keyframes slateZ1 { 
                from { /*动画起始状态*/
                    transform: rotateZ(0deg);
                }
                to { /*动画结束状态*/
                    transform: rotateZ(360deg);
                }
            }
        }
        .btn{
            width: 195px;
            height: 56px;
        }
    }
}
</style>